'use client';

import { cn } from '@noirproperties/ui/lib/utils';
import { useVideoActions } from './video-hooks';

type VideoPlayButtonProps = {
  className?: string;
  children: React.ReactNode;
};

export function VideoPlayButton({ className, children }: VideoPlayButtonProps) {
  const { play } = useVideoActions();

  return (
    <button
      className={cn('text-sm font-semibold leading-6 text-gray-100', className)}
      onClick={play}
      type="button"
    >
      {children}
    </button>
  );
}
